import React, { useEffect, useState } from "react";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Table, Tag } from "antd";
import axios from "axios";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import dayjs from "dayjs";
import useStyledReportColumns from "../useStyledReportColumns";

export default function MonthlyGrossProfitReport({ dateRange, centerName }) {
  const [monthlyGrossProfitReport, setMonthlyGrossProfitReport] = useState([]);
  useEffect(() => {
    if (!dateRange || dateRange.length === 0) {
      setMonthlyGrossProfitReport([]);
      return;
    }

    const fetchMonthlyGrossProfitReport = async () => {
      try {
        const response = await axios.get(
          `${config.baseUrl}/budget/monthly_gross_profit/`,
          {
            headers: authHeader(),
            params: {
              date_range: dateRange,
              center_name: centerName,
            },
          }
        );
        setMonthlyGrossProfitReport(response?.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchMonthlyGrossProfitReport();
  }, [dateRange, centerName]);

  const columns = useStyledReportColumns([
    {
      title: "Month",
      render: (item) => dayjs(item?.month).format("MMMM YYYY"),
    },
    {
      title: "Center",
      dataIndex: "center",
    },
    {
      title: "Total Purchase",
      render: (item) => Number(item?.purchases?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Total Sales",
      render: (item) => Number(item?.sales?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Gross Profit/Loss",
      render: (item) =>
        Number(item?.gross_profit?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Gross Margin(%)",
      render: (item) => item?.gross_profit_margin?.toFixed(2),
    },
    {
      title: "Expense",
      render: (item) => Number(item?.expenses?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Net Profit/Loss",
      render: (item) => Number(item?.net_profit?.toFixed(1))?.toLocaleString(),
    },
    {
      title: "Net Margin(%)",
      render: (item) => item?.net_profit_percentage?.toFixed(2),
    },
  ]);
  const missingFilters = [];

  if (!dateRange || dateRange.length === 0) missingFilters.push("Month Range");

  return (
    <div>
      {missingFilters.length === 0 ? (
        <Table
          className="mt-4 shadow-sm mb-3"
          columns={columns}
          size="small"
          dataSource={monthlyGrossProfitReport}
          pagination={false}
          rowKey={(item) => item?.id}
        />
      ) : (
        <div
          className="d-flex shadow-sm flex-column justify-content-center align-items-center"
          style={{ height: "300px", backgroundColor: "white" }}
        >
          <FilterAltOutlinedIcon style={{ fontSize: 40, color: "#003608" }} />
          <h5>No Data To Display</h5>
          <p>
            Select filters above to view Purchase Report. Your Results will
            appear here once you've made your selections.
          </p>
          <div>
            <small>
              <strong>Required Filters: </strong>
            </small>
            {missingFilters?.map((filter, index) => (
              <Tag key={index} color="#003608">
                {filter}
              </Tag>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
